import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Contact.module.css';
import Eyebrow from '../ui/Eyebrow';

export default function Contact() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <section className={styles.contact} id="contact" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>Get in touch</Eyebrow>
        <h2 className={styles.heading}>Let's talk.</h2>
        <p className={styles.intro}>
          I am open to speaking engagements, consulting conversations, and connecting with people building in similar spaces. The best way to reach me is below.
        </p>
        <div className={styles.links}>
          <a href="https://www.linkedin.com/in/omarisanders" target="_blank" rel="noopener noreferrer" className={styles.contactLink}>
            LinkedIn
          </a>
          <a href="https://substack.com/@omarisanders" target="_blank" rel="noopener noreferrer" className={styles.contactLink}>
            Substack
          </a>
        </div>
      </motion.div>
    </section>
  );
}
